import React from 'react';
import { SlideProps } from '../../../Standard/Shared/ArticlesSlider/Slide';
import ArticlesSlider from '../../../Standard/Shared/ArticlesSlider/ArticlesSlider';
import TitleHeading from 'app_previous/molecules/Shared/TitleHeading/TitleHeading';
import { MoreLikeThisCarouselBackgroundContainer, MoreLikeThisCarouselContainer } from './MoreLikeThisCarousel.styles';

interface MoreLikeThisCarouselProps {
  posts: SlideProps[];
}

const MoreLikeThisCarousel = ({ posts }: MoreLikeThisCarouselProps): JSX.Element => {
  return (
    <MoreLikeThisCarouselBackgroundContainer>
      <MoreLikeThisCarouselContainer>
        <TitleHeading
          title='MORE LIKE THIS'
          size='1.5rem'
        />
        <ArticlesSlider slides={posts} />
      </MoreLikeThisCarouselContainer>
    </MoreLikeThisCarouselBackgroundContainer>
  );
};

export default MoreLikeThisCarousel;
